import type { IApplicationState } from '../../types/store';

export function isAgentSelector(state: IApplicationState): boolean {
  return !!state.userData.user?.isAuthenticated && !!state.userData.user.isAgent;
}
